import React from 'react';
import useGlobal from 'global-state/store';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export default function GlobalSnackbar() {
  const [globalState, globalActions] = useGlobal();

  return (
    <Snackbar
      open={globalState.globalSnackbar.display}
      autoHideDuration={5000}
      onClose={() => globalActions.closeSnackbar()}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity={globalState.globalSnackbar.severity}
        variant="filled"
        sx={{ px: 2.5, py: 1, boxShadow: 3 }}
      >
        {globalState.globalSnackbar.message}
      </Alert>
    </Snackbar>
  );
}
